import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, CheckCircle } from "lucide-react";

const certificationLogos = [
  {
    id: "ideam",
    src: "/Images/ideam.webp",
    alt: "Acreditación IDEAM",
  },
  {
    id: "iso9001",
    src: "/Images/isos9001.webp",
    alt: "Certificación ISO 9001",
    caption: "Certificado No. GC 721",
  },
  {
    id: "iso14001",
    src: "/Images/isos14001.webp",
    alt: "Certificación ISO 14001",
    caption: "Certificado No. GA 669",
  },
  {
    id: "iso45001",
    src: "/Images/isos45001.webp",
    alt: "Certificación ISO 45001",
    caption: "Certificado No. OS 777",
  },
];

export default function Certifications() {
  return (
    <section className="relative overflow-hidden  from-white via-[#fffaf7] to-[#fff3eb] py-20">
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-20 items-center">
          <div>
            <h1 className="text-4xl md:text-5xl xl:text-6xl font-bold text-[#243447] leading-tight mb-8">
              Nuestras
              <span className="block text-[#ee7d32]">Certificaciones</span>
            </h1>

            <div className="space-y-5 text-gray-600 leading-relaxed text-lg">
              <p>
                En{" "}
                <strong className="text-[#243447]">
                  Sierra Alta SAS - Energy & Environmental Services
                </strong>
                , nos enorgullece contar con certificaciones que reflejan
                nuestro compromiso con la excelencia, sostenibilidad y
                seguridad.
              </p>

              <p>
                Contamos con la acreditación otorgada por el{" "}
                <strong className="text-[#243447]">IDEAM</strong>, que nos
                faculta oficialmente para generar información cuantitativa en
                parámetros físicos y químicos, con fines ambientales. Esta
                certificación nos permite participar en estudios y análisis
                exigidos por las Autoridades Ambientales, asegurando el
                cumplimiento de la normativa colombiana en materia de calidad
                ambiental y conservación de los recursos naturales renovables.
              </p>

              <p>
                Asimismo, el{" "}
                <strong className="text-[#243447]">
                  RUC (Registro Único de Contratistas)
                </strong>{" "}
                avala nuestra gestión en seguridad y salud en el trabajo,
                demostrando nuestro compromiso con el bienestar de nuestros
                colaboradores y la responsabilidad en nuestras operaciones.
              </p>

              <p>
                A nivel internacional contamos con las certificaciones{" "}
                <strong className="text-[#243447]">ISO 9001</strong>,{" "}
                <strong className="text-[#243447]">ISO 14001</strong> y{" "}
                <strong className="text-[#243447]">ISO 45001</strong>.
              </p>

              <p>
                Estos reconocimientos nos posicionan como un aliado estratégico
                y confiable dentro del sector energético y ambiental.
              </p>
            </div>

            <div className="mt-10">
              <Link
                to="/contact-us"
                className="
                  group
                  relative
                  overflow-hidden
                  inline-flex
                  items-center
                  justify-center
                  gap-3
                  px-8
                  py-5
                  rounded-2xl
                  bg-gradient-to-r
                  from-[#ee7d32]
                  to-[#ff9d58]
                  text-white
                  font-semibold
                  shadow-[0_20px_40px_rgba(238,125,50,.35)]
                  hover:-translate-y-1
                  hover:scale-[1.02]
                  transition-all
                  duration-300
                "
              >
                <span
                  className="
                    absolute
                    inset-0
                    -translate-x-full
                    bg-gradient-to-r
                    from-transparent
                    via-white/20
                    to-transparent
                    group-hover:translate-x-full
                    transition-transform
                    duration-700
                  "
                />

                <span className="relative z-10 text-white">
                  Solicitar información
                </span>

                <ArrowRight
                  size={18}
                  className="relative z-10 transition-transform duration-300 group-hover:translate-x-2"
                  stroke="white"
                />
              </Link>
            </div>
          </div>

          <div>
            <div className="grid grid-cols-2 gap-8">
              {certificationLogos.map((cert) => (
                <div
                  key={cert.id}
                  className="
                    group
                    relative
                    overflow-hidden
                    rounded-[32px]
                    bg-white
                    p-8
                    border
                    border-white
                    shadow-[0_15px_45px_rgba(0,0,0,0.08)]
                    hover:shadow-[0_25px_60px_rgba(238,125,50,0.18)]
                    hover:-translate-y-2
                    transition-all
                    duration-500
                  "
                >
                  <div
                    className="
                      absolute
                      inset-0
                      opacity-0
                      group-hover:opacity-100
                      transition-opacity
                      duration-500
                      bg-gradient-to-br
                      from-[#ee7d32]/5
                      via-transparent
                      to-[#ee7d32]/10
                    "
                  />

                  <div className="relative z-10">
                    <div className="h-44 flex items-center justify-center">
                      <img
                        src={cert.src}
                        alt={cert.alt}
                        loading="lazy"
                        className="
                          max-h-32
                          object-contain
                          transition-all
                          duration-500
                          group-hover:scale-110
                        "
                      />
                    </div>

                    {cert.caption && (
                      <div className="mt-5 text-center">
                        <span
                          className="
                            inline-flex
                            px-4
                            py-2
                            rounded-full
                            bg-[#fff4ec]
                            text-[#ee7d32]
                            text-xs
                            font-semibold
                          "
                        >
                          {cert.caption}
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>

            <div
              className="
                relative
                overflow-hidden
                mt-8
                rounded-[36px]
                bg-gradient-to-br
                from-[#ee7d32]
                via-[#f18a40]
                to-[#ff9d58]
                p-10
                text-white
                shadow-[0_10px_20px_rgba(238,125,50,.35)]
              "
            >
              <div className="absolute -right-10 -top-10 w-40 h-40 rounded-full bg-white/10" />
              <div className="absolute right-10 bottom-0 w-24 h-24 rounded-full bg-white/10" />

              <div className="relative z-10">
                <div className="flex items-center gap-5 mb-5">
                  <div className="w-16 h-16 rounded-2xl backdrop-blur-sm flex items-center justify-center">
                    <CheckCircle
                      size={30}
                      strokeWidth={2.5}
                      className="drop-shadow-lg"
                      stroke="white"
                    />
                  </div>

                  <div>
                    <h3 className="text-2xl font-bold text-white">
                      Compromiso Certificado
                    </h3>

                    <p className="text-orange-100">
                      Estándares nacionales e internacionales
                    </p>
                  </div>
                </div>

                <p className="text-white/90 leading-relaxed">
                  Garantizamos procesos alineados con las mejores prácticas de
                  calidad, gestión ambiental y seguridad ocupacional para
                  brindar soluciones confiables, sostenibles y seguras a
                  nuestros clientes.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
